<template>
  <v-data-table
    :footer-props="{
      'items-per-page-text': 'Số dữ liệu mỗi trang',
      'items-per-page-options': [10, 20, 50]
    }"
    :headers="headers"
    :items="items"
    :loading="loading"
    :items-per-page="itemsPerPage"
    :server-items-length="count"
    @update:page="val => updatePagination('page', val)"
    @update:items-per-page="val => updatePagination('itemsPerPage', val)"
    disable-sort
    hide-default-header
  >
    <template v-slot:header>
      <thead>
        <tr>
          <th
            v-for="header in headers"
            :key="header.value"
            :style="{ 'text-align': header.align ? header.align : 'left' }"
          >
            <span v-html="header.text"></span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:no-data>
      <div class="my-12 font-weight-bold">
        <p>Không có dữ liệu</p>
      </div>
    </template>
    <template v-slot:[`body.prepend`]>
      <tr>
        <td colspan="1">
          <BaseSmallInput :style="{ width: '120px' }" placeholder="Nhập mã đơn" v-model="filter.code_contains" @change="searchWithOption()" />
        </td>
        <td colspan="1">
          <SmallSelect
          :style="{ width: '90px' }"
            placeholder="Chọn NH"
            entity="industries"
            @changeSelect="
              val => {
                filter.productIndustry = val
                searchWithOption()
                selectChange('productIndustry', val)
              }
            "
          />
        </td>
        <td colspan="1">
          <SmallSelect
            :style="{ width: '100px' }"
            ref="producerSelect"
            placeholder="Chọn NSX"
            entity="producers"
            :params="{ productIndustry: filter.productIndustry }"
            @changeSelect="
              val => {
                selectChange('producer', val)
                searchWithOption()
              }
            "
          />
        </td>
        <td colspan="1">
          <SmallSelect
          :style="{ width: '115px' }"
            ref="productTypeSelect"
            placeholder="Chọn CH"
            entity="productTypes"
            :params="{ producer: filter.producer, productIndustry: filter.productIndustry }"
            @changeSelect="
              val => {
                selectChange('productType', val)
                searchWithOption()
              }
            "
          />
        </td>
        <td colspan="1" :style="{ width: '120px' }" style="text-align: end; color:red">{{ Number(stat).toLocaleString('en-US') }}</td>
        <td colspan="1">
          <BaseSmallInput
          :style="{ width: '500px' }"
            placeholder="Nhập mã HĐ"
            maxWidth="100%"
            v-model="filter.invoiceCode_contains"
            @change="searchWithOption()"
          />
        </td>
        <td colspan="1">
          <StatusSelect
          :style="{ width: '120px' }"
            :items="status"
            placeholder="Chọn TT"
            @onChangeStatus="
              val => {
                filter.status = val
                searchWithOption()
              }
            "
          />
        </td>
      </tr>
    </template>
    <template v-slot:[`item.code`]="{ item }">
      <div class="primary--text code-actions" @click="$router.push(`/import-order/${item.id}`)">
        {{ item.code }}
      </div>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <div :class="item.status ? 'success--text' : 'error--text'">
        {{ item.invoiceStatus === 'full' ? 'Đã đủ HĐ' : item.invoiceStatus === 'notFull' ? 'Chưa đủ HĐ' : '' }}
      </div>
    </template>
    <template v-slot:[`item.billInvoices`]="{ item }">
      <div class="d-flex flex-wrap" v-if="Array.isArray(item.invoices) && item.invoices.length">
        <div v-for="(code, cIdx) in item.invoices" :key="cIdx">
          <div class="d-flex mr-1">
            <div
              class="code-actions"
              @click="() => goToBill(item.invoices[cIdx])"
              :class="code.code ? 'primary--text' : 'error--text'"
            >
              {{ `${get(code, 'code', '[Chưa có mã]')}, ` }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>{{ '--' }}</div>
    </template>
    <template v-slot:[`item.expectedWorth`]="{ item }">
      {{ item.expectedWorth ? Number(item.expectedWorth).toLocaleString('en-US') : '--' }}
    </template>
    <template v-slot:[`item.productIndustry`]="{ item }">
      {{ item.productIndustry.name || '--' }}
    </template>
    <template v-slot:[`item.producer`]="{ item }">
      {{ item.producer.name || '--' }}
    </template>
    <template v-slot:[`item.productType`]="{ item }">
      {{ item.productType.name || '--' }}
    </template>
  </v-data-table>
</template>

<script>
import { formatDateDDMMYYYY } from '@/helpers/date.js'
import SmallSelect from '../../components/samnec/SmallSelect.vue'
import BaseSmallInput from '../../components/basic/BaseSmallInput.vue'
import StatusSelect from '../../components/basic/StatusSelect.vue'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
export default {
  components: { SmallSelect, BaseSmallInput, StatusSelect },
  computed: {
    ...mapState({
      itemsPerPage(state) {
        return state['verifyImport'].itemsPerPage
      },
      searchQuery(state) {
        return state['verifyImport'].searchQuery
      },
      items(state) {
        return state['verifyImport'].items
      },
      loading(state) {
        return state['verifyImport'].loading
      },
      count(state) {
        return state['verifyImport'].count
      },
      stat(state) {
        return state['verifyImport'].stat
      }
    })
  },
  data() {
    return {
      headers: [
        { text: '<div style="width: 120px">Đơn hàng nhập</div>', value: 'code' },
        { text: '<div style="width: 90px">Ngành hàng</div>', value: 'productIndustry' },
        { text: '<div style="width: 100px">NSX</div>', value: 'producer' },
        { text: '<div style="width: 115px">Chủng hàng</div>', value: 'productType' },
        { text: '<div style="width: 120px">Tổng giá trị</div>', value: 'expectedWorth', align: 'end' },
        { text: '<div style="width: 500px">Danh sách hoá đơn nhập</div>', value: 'billInvoices' },
        { text: '<div style="width: 120px">Trạng thái đối soát</div>', value: 'status' }
      ],
      status: [
        { label: 'Đã đủ HĐ', value: true, color: 'success' },
        { label: 'Chưa đủ HĐ', value: false, color: 'error' }
      ],
      filter: {
        code_contains: '',
        productIndustry: null,
        producer: null,
        productType: null,
        invoiceCode_contains: null
      },
      get
    }
  },
  methods: {
    ...mapActions({
      setItemsPerPage: 'verifyImport/setItemsPerPage',
      setSearchQuery: 'verifyImport/setSearchQuery',
      fetchVerifyOrders: 'verifyImport/fetchItems',
      countVerifyOrders: 'verifyImport/countItems',
      fetchBill: 'importInvoices/fetchOne',
      getStats: 'verifyImport/getStat'
    }),
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      const params = {
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.searchQuery
      }
      await this.fetchVerifyOrders({ ...params })
      this.setItemsPerPage(itemsPerPage)
    },
    goToBill(code) {
      this.$router.push(`/import-bill/${code.id}`)
    },
    async searchWithOption() {
      const params = {
        ...this.searchQuery,
        ...this.filter
      }
      await this.fetchVerifyOrders({ ...params })
      await this.countVerifyOrders({ ...params })
      await this.getStats({ ...params })
      this.setSearchQuery(params)
    },
    selectChange(type, val) {
      if (type === 'productIndustry') {
        this.filter.productIndustry = val
        setTimeout(() => {
          this.$refs.producerSelect.changeItems()
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
      if (type === 'producer') {
        this.filter.producer = val
        setTimeout(() => {
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.code-actions {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
